import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useReduxOrg } from '@Hooks/reduxOrgHook/useReduxOrg';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { setPermission, setJourney, setAccessList, setPreference, setCurrentUser, setSeatExpired, clearAll } from '@Redux/activeUser/activeUserActions';

export const useReduxActiveUser = () => {

    const dispatch = useDispatch();
    const { currentOrgId } = useReduxOrg();
    const { currentProjectId } = useReduxProject();
    const permission = useSelector((state) => state.activeUser.permission);
    const journey = useSelector((state) => state.activeUser.journey);
    const accessList = useSelector((state) => state.activeUser.accessList);
    const preferences = useSelector((state) => state.activeUser.preference);
    const currentUser = useSelector((state) => state.activeUser.currentUser);
    const userSeatExpired = useSelector((state) => state.activeUser.userSeatExpired);
    const activeUserId = currentUser?.id ?? 0;
    const currentUserOrgPermissions = !!permission.orgs ? permission?.orgs[currentOrgId] : {};
    const currentUserProjectPermissions = !!permission.projects ? permission?.projects[currentProjectId] : {};

    const setActiveUserPermission = useCallback(
        async (permission) => dispatch(setPermission(permission)),
        [dispatch]
    );

    const setActiveUserJourney = useCallback(
        async (journey) => dispatch(setJourney(journey)),
        [dispatch]
    );

    const setActiveUserAccessList = useCallback(
        async (accessList) => dispatch(setAccessList(accessList)),
        [dispatch]
    );

    const setActiveUserPreference = useCallback(
        async (preferences) => {
                let preferenceObj = preferences;
                preferenceObj.email = typeof preferenceObj.email === 'string' ? JSON.parse(preferenceObj.email) : preferenceObj.email;
                preferenceObj.whatsapp = typeof preferenceObj.whatsapp === 'string' ? JSON.parse(preferenceObj.whatsapp) : preferenceObj.whatsapp;
                preferenceObj.preferences = typeof preferenceObj.preferences === 'string' ? JSON.parse(preferenceObj.preferences) : preferenceObj.preferences;
                dispatch(setPreference(preferenceObj))
            },
        [dispatch]
    );

    const setActiveUser = useCallback(
        async (user) => dispatch(setCurrentUser(user)),
        [dispatch]
    );

    const clearAllData = useCallback(
        () => dispatch(clearAll()),
        [dispatch]
    );

    const setUserSeatExpired = useCallback(
        async (seatExpired) => dispatch(setSeatExpired(seatExpired)),
        [dispatch]
    );

    return {
        activeUserPermissions: permission,
        activeUserJourney: journey,
        activeUserAccessList: accessList,
        activeUserPreferencesAll: preferences,
        activeUserPreferences: preferences.preferences,
        activeUser: currentUser,
        activeUserId: activeUserId,
        setActiveUserPermission: setActiveUserPermission,
        setActiveUserJourney: setActiveUserJourney,
        setActiveUserAccessList: setActiveUserAccessList,
        setActiveUserPreferencesAll: setActiveUserPreference,
        setActiveUser: setActiveUser,
        userSeatExpired: userSeatExpired,
        setUserSeatExpired: setUserSeatExpired,
        clearAllUserData: clearAllData
    }
}